export default __webpack_public_path__ + "assets/04_MapLayers.png";